import { startOfDay } from 'date-fns'

export const convertDateToUTC = (date: Date): Date => {
  const localMidnight = startOfDay(date) // Ensures 00:00:00 in local time

  return new Date(Date.UTC(localMidnight.getFullYear(), localMidnight.getMonth(), localMidnight.getDate()))
}
